<div class="d-flex flex-column bg-white rounded-2 p-4 gap-2">
  <div class="d-flex flex-wrap gap-4">
    <div class="icon-logo"><img src="/assets/svgs/integrations/telegram_bot.png" alt="Telegram logo" /></div>
    <div>
      <h5>{{ 'add_a_phone_number' | translate }}</h5>
      <p>{{ 'you_can_delete_at_any_time' | translate }}</p>
      <div class="d-flex gap-2 flex-wrap">
        <app-phone-field
          (keydown.enter)="addPhone()"
          customClass="h-36"
          [inputValue]="phoneInput"
          (valueChanged)="phoneInput = $event"
        ></app-phone-field>
        <app-button (onChangeClick)="addPhone()" [disabled]="!phoneInput">{{ 'add' | translate }}</app-button>
      </div>
    </div>
  </div>
  <div>
    <h5>{{ 'connection_instructions' | translate }}:</h5>
    <div>
      <div>1. {{ 'add_users_who_will_have_access_to_Telegram' | translate }}.</div>
      <div>2. {{ 'go_to_the_Telegram_bot_and_register' | translate }}.</div>
      <div>
        {{ 'the_bot_is_available_at_this_link' | translate }}:
        <a href="https://t.me/{{ environment.logistic.telegram }}" target="_blank"
          >&#64;{{ environment.logistic.telegram }}</a
        >
      </div>
    </div>
  </div>
</div>

<div class="bg-white rounded shadow">
  <div class="profile-edit-box m-4">
    <div class="d-flex align-items-center">
      <app-search (onValueChange)="onSearchChange($event)"></app-search>
      <div class="flex-fill"></div>
    </div>
    @if (isLoader) {
      <div class="d-flex justify-content-center">
        <app-loader size="small"></app-loader>
      </div>
    } @else {
      @if (dataSource$ | async; as dataSource) {
        <app-table
          class="w-100"
          [dataSource]="dataSource"
          [visibleColumnKeys]="visibleColumns"
          (onSortChange)="onSortChange($event)"
          (onPaginationChange)="onPaginationChange($event)"
          (menuSelected)="onActionChange($event)"
        ></app-table>
      }
    }
  </div>
</div>
